import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css'

import RMS_ICONS from '@/icons'

import './custom.styl';

Vue.use (Vuetify, {
    iconfont: 'mdi',
    icons: RMS_ICONS,
    breakpoint: {
      thresholds: {
        xs: 360,
      },
    },
    theme: {
      primary: '#2BB1FF',
      secondary: '#B2DBBF',
      accent: '#028090',
      error: '#FF1654',
      info: '#71BCF7',
  success: '#02C39A',
  warning: '#FF9F1C'
    }
});

